export default __webpack_public_path__ + "static/media/loading.29bc9b75.gif";